import Cookies, { CookieAttributes } from 'js-cookie'
import { AxiosInstance } from '../codegen/AxiosInstance'

export const AUTH_COOKIE = 'logicomix-auth'
export const AUTH_COOKIE_OPTIONS = {
  expires: 7,
  secure: true,
  sameSite: 'strict',
} as CookieAttributes

export function getJWT(): string {
  return Cookies.get(AUTH_COOKIE) || ''
}

export const initAxiosAuthInterceptor = (token?: string) => {
  AxiosInstance.interceptors.request.use(config => {
    if (config.headers) {
      // Add token if available
      const jwtToken = token ?? getJWT()
      if (jwtToken) {
        config.headers.Authorization = `Bearer ${jwtToken}`
      }
    }

    return config
  })

  AxiosInstance.interceptors.response.use(
    config => {
      return config
    },
    error => {
      if (error?.response?.status === 401) {
        Cookies.remove(AUTH_COOKIE)

        window.history.pushState({ urlPath: '/login' }, '', '/login')
        window.location.reload()
      }
      return Promise.reject(error)
    },
  )
}
